import { RankedDivisionTypes, RankedSubDivisionTypes } from '@colonist/leaderboard-types';
import { ColonistMembershipType } from '@colonist/types';
import IconRankBronze from '@static/images/ranking_divisions/bronze.svg';
import IconRankSilver from '@static/images/ranking_divisions/silver.svg';
import IconRankGold from '@static/images/ranking_divisions/gold.svg';
import IconRankPlatinum from '@static/images/ranking_divisions/platinum.svg';
import IconRankDiamond from '@static/images/ranking_divisions/diamond.svg';
import IconRankMaster from '@static/images/ranking_divisions/master.svg';
import IconRankGrandmaster from '@static/images/ranking_divisions/grandmaster.svg';
import IconRankSubdivisionI from '@static/images/ranking_divisions/subdivisions_i.svg';
import IconRankSubdivisionII from '@static/images/ranking_divisions/subdivisions_ii.svg';
import IconRankSubdivisionIII from '@static/images/ranking_divisions/subdivisions_iii.svg';
import IconRankSubdivisionIV from '@static/images/ranking_divisions/subdivisions_iv.svg';
import IconRankSubdivisionV from '@static/images/ranking_divisions/subdivisions_v.svg';
import IconMembershipPlus from '@static/images/membership_icon_plus.svg';
import IconMembershipPremium from '@static/images/membership_icon_premium.svg';
import IconMembershipElite from '@static/images/membership_icon_elite.svg';
import IconMembershipHoliday2023 from '@static/images/membership_icon_holiday2023.svg';
import { getNestedTranslation, passThroughTranslation } from '@colonist/i18n';
import { EnumUtils } from '@colonist/utils';
export const getRankedDivisionImage = (division)=>{
    if (division === RankedDivisionTypes.None) return;
    switch(division){
        case RankedDivisionTypes.Bronze:
            return IconRankBronze;
        case RankedDivisionTypes.Silver:
            return IconRankSilver;
        case RankedDivisionTypes.Gold:
            return IconRankGold;
        case RankedDivisionTypes.Platinum:
            return IconRankPlatinum;
        case RankedDivisionTypes.Diamond:
            return IconRankDiamond;
        case RankedDivisionTypes.Master:
            return IconRankMaster;
        case RankedDivisionTypes.Grandmaster:
            return IconRankGrandmaster;
    }
};
export const getRankedSubdivisionImage = (subdivision)=>{
    if (subdivision === RankedSubDivisionTypes.None) return;
    switch(subdivision){
        case RankedSubDivisionTypes.I:
            return IconRankSubdivisionI;
        case RankedSubDivisionTypes.II:
            return IconRankSubdivisionII;
        case RankedSubDivisionTypes.III:
            return IconRankSubdivisionIII;
        case RankedSubDivisionTypes.IV:
            return IconRankSubdivisionIV;
        case RankedSubDivisionTypes.V:
            return IconRankSubdivisionV;
    }
};
export function getRankedDivisionText(rankedDivision) {
    const rankedDivisionKey = EnumUtils.getEnumKey(rankedDivision, RankedDivisionTypes);
    return {
        key: `strings:leaderboardPage.rankedDivision.${rankedDivisionKey}`
    };
}
export const getRankedFullDivisionText = (rankedDivision, rankedSubDivision)=>{
    const subDivisionName = rankedSubDivision == RankedSubDivisionTypes.None ? '' : RankedSubDivisionTypes[rankedSubDivision];
    return getNestedTranslation({
        key: 'strings:leaderboardPage.rankedFullDivision'
    }, {
        rankedDivision: getRankedDivisionText(rankedDivision),
        rankedSubDivision: passThroughTranslation(subDivisionName)
    });
};
export const getMembershipImage = (membershipType)=>{
    switch(membershipType){
        case ColonistMembershipType.PlusMonthly:
        case ColonistMembershipType.PlusYearly:
            return IconMembershipPlus;
        case ColonistMembershipType.PremiumMonthly:
        case ColonistMembershipType.PremiumYearly:
            return IconMembershipPremium;
        case ColonistMembershipType.EliteMonthly:
        case ColonistMembershipType.EliteYearly:
            return IconMembershipElite;
        case ColonistMembershipType.Holiday2023AllAccessPass:
            return IconMembershipHoliday2023;
    }
};
export const getMembershipTitle = (membershipType)=>{
    switch(membershipType){
        case ColonistMembershipType.PlusMonthly:
        case ColonistMembershipType.PlusYearly:
            return {
                key: 'strings:storePage.membership.title.plus'
            };
        case ColonistMembershipType.PremiumMonthly:
        case ColonistMembershipType.PremiumYearly:
            return {
                key: 'strings:storePage.membership.title.premium'
            };
        case ColonistMembershipType.EliteMonthly:
        case ColonistMembershipType.EliteYearly:
            return {
                key: 'strings:storePage.membership.title.elite'
            };
        case ColonistMembershipType.Holiday2023AllAccessPass:
            return {
                key: 'strings:storePage.membership.title.holiday2023'
            };
    }
};
